import { ReactNode, ReactElement } from 'react';
import { Grid } from '@mui/material';

interface CenteredComponentViewProps {
  children: ReactNode;
}
export default function CenteredComponentView({ children }: CenteredComponentViewProps): ReactElement {
  return (
    <Grid container justifyContent="center" alignContent="center" sx={{ height: 'calc(100vh - 96px)' }}>
      <Grid item>{children}</Grid>
    </Grid>
  );
}
